import type { GlbSceneConfig } from '../glb/glbSceneConfig';
import { resolveCdnUrl } from '../../utils/cdnUrl';

export const maqamIbrahimSceneConfig: GlbSceneConfig = {
  id: 'maqam-ibrahim-scene',
  bgTheme: 'black',
  renderer: {
    maxPixelRatio: 2,
  },
  camera: {
    fov: 60,
    near: 0.01,
    far: 100,
    initialPosition: { x: 2.0351, y: 0.3323, z: 4.16 },
    initialTarget: { x: 0, y: 0, z: 0 },
  },
  controls: {
    target: { x: 0, y: 0, z: 0 },
    minDistance: 1,
    maxDistance: 8,
    enablePan: false,
    enableDamping: true,
    dampingFactor: 0.08,
  },
  models: [
    {
      key: 'maqam-ibrahim-scene',
      url: resolveCdnUrl('models/poi-artifacts/maquam_metalic.glb'),
    },
  ],
  environment: {
    hemisphereLight: {
      skyColor: 0xffffff,
      groundColor: 0x444444,
      intensity: 0.8,
    },
    directionalLights: [
      {
        color: 0xffffff,
        intensity: 1.2,
        position: { x: 2, y: 3, z: 2 },
      },
      {
        color: 0xffd700,
        intensity: 0.4,
        position: { x: -1, y: 1, z: -2 },
      },
    ],
  },
  collision: {
    cameraRadius: 0.3,
  },
};
